import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {CurrencyPipe} from "@angular/common";
import {HttpStatusCode} from "@angular/common/http";
import {forkJoin} from "rxjs";
import {ResponseHttpError, ResponseHttpSuccess} from "library";

enum  stepOptions {
  'selection' = 'selection',
  'summary' = 'summary',
  'pay' = 'pay',
  'qrcode' = 'qrcode',

}

@Component({
  selector: 'app-sales-quotas',
  templateUrl: './sales-quotas.component.html'
})
export class SalesQuotasComponent implements OnInit{
  stepOptions = stepOptions;
  step = stepOptions.selection;
  requestId: any;
  categoryId: any;
  product: any;
  productsListByCategory: any = [];
  productFilter: any = [];
  selectedQuote: any;
  viewPaymentAdd = false;
  installment: any = [];
  installmentsLille: any = [];
  installmentsBig: any = [];
  quotesByProduct : any = [];
  request: any = {};
  flowCode: string;
  @Output() nextStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private currencyPipe: CurrencyPipe,
              private pathNavigationService: PathNavigationService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryId = this.route.snapshot.params['category_id'];
    this.request = this.requestService.request;
    this.flowCode = this.route.snapshot.params['flow_code'];
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.utilService.enablePageLoading();

    this.requestService.getProductsByCategory(this.requestId, this.categoryId).subscribe({
      next: (responses) => {
        this.product = this.request.product;
        const productsResponse = responses;
        if (productsResponse.status === HttpStatusCode.Ok) {
          this.productsListByCategory = productsResponse.body.data.list;
          console.log(this.productsListByCategory);
          this.onFilterProductSelected(this.product);
        } else {
          this.customMessageService.responseNoticeHandler(responses);
        }
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
      },
      complete: () => {
        this.utilService.disablePageLoading();
      }
    });
  }

  onFilterProductSelected(product: any) {
    // TODO no se muestran ordenadas la cantidad de cuotas
    this.productFilter = this.productsListByCategory.find((productItem: any) => productItem.id === product.id);
    console.log(this.productFilter.quotes)
    this.productFilter.quotes = this.productFilter.quotes.sort((a: any, b: any) => a.quota.quantity < b.quota.quantity)
    this.quotesByProduct = this.productFilter.quotes;
    this.onReturnValueInstallment(this.quotesByProduct);
  }

  getLabelProduct(quote: any) {
    return `En ${quote.quantity} cuotas y pagaré ${this.currencyPipe.transform(quote.from)} `
  }

  onSelectedQuote(quote: any) {
    quote.installment.selected = quote.installment.from;
    quote.prices.selected = quote.prices.suggested;
    quote.quota.selected = quote.quota.from;

    this.utilService.enablePageLoading()
    const data = {quotes: quote};
    this.requestService.update(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.NoContent) {
          this.nextStepEvent.emit();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        if ( error.status === HttpStatusCode.Locked) {
          this.handleRequestLocked(error as any);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
      }
    });
  }

  onReturnValueInstallment(quotes: any){
    const [firstQuote] = quotes;
    for(let i = firstQuote.installment.min; i <= firstQuote.installment.max; i+=5) {
      let quote = (i * firstQuote.prices.suggested) / 100;
      quote = parseFloat(quote.toFixed(2))
      this.installment.push(quote);
      this.installmentsLille = this.installment.slice(0, 3);
      this.installmentsBig = this.installment.slice(4);
    }

  }

  private handleRequestLocked(resp: any): void {
    const messageError = resp.error?.message ?? 'Solicitud no disponible';
    const attemptedUrl = this.utilService.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotAvailable(this.flowCode, state);
  }

  /*
    onCreateDataStructure($event: any){
      let data = {
        price: this.quotesByProduct[0].prices.suggested,
        installment: $event,
        quotas: this.quotesByProduct.map( (quote: any) => ({
          quantity: quote.quota.quantity,
          name: quote.quota.name,
          monthly_interest: quote.monthly_interest
        }))
      };
      this.getQuotaCalculation(data);

    }

    getQuotaCalculation(data: any){
      this.utilService.enablePageLoading();
      this.requestService.getThCalculationOfCreditInstallments(data).subscribe({
        next: (resp: ResponseHttpSuccess) => {
          if (resp.status === HttpStatusCode.Ok) {
            const responseQuotas = resp.body.data.list;
            this.quotesByProduct.forEach((item: any, index: any) => {
              const responseQuota = responseQuotas[index];
              if (responseQuota){
                item.quota.quantity = responseQuota.quantity;
                item.quota.name = responseQuota.name;
                item.quota.from = responseQuota.payment;
                item.monthly_interest = responseQuota.monthly_interest;
              }
            })
            this.step = stepOptions.selection;
          }else{
            this.customMessageService.responseNoticeHandler(resp);
          }
          this.utilService.disablePageLoading();
        },
        error: (resp: ResponseHttpError) => {
          this.customMessageService.responseNoticeHandler(error);
          this.utilService.disablePageLoading();
        },
      })
    }

    onNextStep(step: any){
      this.step = step;
    }

    onConfirm(step: any){
      this.onNextStep(step);
    }
  */


}
